import { createIsomorphicFn } from '@tanstack/react-start';
import { getCookie as getServerCookie } from '@tanstack/react-start/server';
import Cookies from 'js-cookie';

export const getCookie = createIsomorphicFn()
  .server((name: string) => {
    return getServerCookie(name);
  })
  .client((name: string) => {
    return Cookies.get(name);
  });
